/* eslint-disable react/prop-types */
import axios from "utils/httpClient";
import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Chart } from "chart.js";
import { defaults } from "react-chartjs-2";
import loading from "assets/img/loading-load.gif";

const ChartBar = props => {
  const [chart, setChart] = useState({});
  //const [isFetch, setIsFetch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [displayTitle] = useState(true);
  const [displayLegend] = useState(true);
  var [legendPosition] = useState("right");
  // var [location] = useState("City");
  var [tap] = useState("");
  var [option2] = useState("");
  var [option3] = useState("");
  var [option4] = useState("");
  var [option5] = useState("");
  const [name, setName] = useState("");

  const monthNames = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม"
  ];

  // if (props.location !== null) {
  //   location = props.location;
  // }

  if (props.legendPosition !== null) {
    legendPosition = props.legendPosition;
  }

  // const chartData = () => {
  //   setChartData(props.chartData);
  // };

  // const handleChange = (time) => {
  //   var d = new Date(time);
  //   var c = new Date().toLocaleString();
  //   var e = new Date(c);
  //   var daysDiff = Math.round((e-d)/86400000);
  //   props.callbackFunction(daysDiff.toString())
  // }

  function handleChange(e) {
    props.checkFetch(e);
  }

  function setExportData(e) {
    props.exportData(e);
  }

  useEffect(() => {
    if (props.option2 !== "") {
      option2 = props.option2;
    } else {
      option2 = 0;
    }
    if (props.option3 !== "") {
      option3 = props.option3;
    } else {
      option3 = 0;
    }
    if (props.option4 !== "") {
      option4 = props.option4;
    } else {
      option4 = 0;
    }
    if (props.option5 !== "") {
      option5 = props.option5;
    } else {
      option5 = 0;
    }

    if (props.tap !== "" || props.tap !== undefined) {
      tap = props.tap;
    } else {
      tap = 1;
    }

    var data = 0;
    if (option3 === 0) {
      data = option2;
      option2 = 0;
      option3 = 0;
      option4 = 0;
    } else if (option4 === 0 && option5 === 0) {
      data = option3;
      option3 = 0;
      option4 = 0;
    } else if (option4 !== 0 && option5 === 0) {
      data = option4;
      option4 = 0;
    } else if (option4 !== 0 && option5 !== 0) {
      data = option5;
    }

    if (
      props.oldTap === "" ||
      (props.year !== "" && props.oldTap === "") ||
      (props.year !== 0 && props.oldTap === "") ||
      (props.oldTap !== "" &&
        props.option2 !== 0 &&
        props.tap !== "" &&
        props.option3 === 0) ||
      props.isCheck
    ) {
      axios("/api/v1/data/info/" + data)
        .then(response => response.data)
        .then(
          result => {
            handleChange(result.isFetch);
            if (!result.isFetch) {
              axios(
                "/api/v1/data/bar?tap=" +
                  tap +
                  "&year=" +
                  props.year +
                  "&group2=" +
                  option2 +
                  "&group3=" +
                  option3 +
                  "&group4=" +
                  option4 +
                  "&data=" +
                  data +
                  "&filter=" +
                  props.filter,
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    if (
                      result.data.name !== null &&
                      result.data.name !== undefined &&
                      result.data.name !== ""
                    ) {
                      setName(result.data.name);
                    } else {
                      setName("");
                    }
                    if (props.year !== "") {
                      var mockData =
                        '{ "datasets" : [' +
                        '{ "label":"Peter" , "lastName":"Jones" } ]}';
                      var obj = JSON.parse(mockData);
                      setChart(obj);
                    }
                    // handleChange(result.data.isFetch);
                    setChart(result.data);
                    setExportData(result.data);
                    //console.log(result.data)
                  },
                  error => {
                    console.log(error);
                  }
                );
            } else {
              const fetchData = async () => {
                setIsLoading(true);
                const response = await axios(
                  "/api/v1/data/barFetch?tap=" +
                    tap +
                    "&year=" +
                    props.year +
                    "&group2=" +
                    option2 +
                    "&group3=" +
                    option3 +
                    "&group4=" +
                    option4 +
                    "&data=" +
                    data +
                    "&filter=" +
                    props.filter +
                    "&serviceUnit=" +
                    props.serviceUnitFilter
                );
                if (response.status !== 200) {
                  console.log("");
                } else {
                  const data = response.data;
                  if (
                    data.data.name !== null &&
                    data.data.name !== undefined &&
                    data.data.name !== ""
                  ) {
                    setName(
                      data.data.name + " (" + props.serviceUnitName + ")"
                    );
                  } else {
                    setName("");
                  }
                  if (props.year !== "") {
                    var mockData =
                      '{ "datasets" : [' +
                      '{ "label":"Peter" , "lastName":"Jones" } ]}';
                    var obj = JSON.parse(mockData);
                    setChart(obj);
                  }
                  // setIsFetch(result.data.isFetch);
                  setChart(data.data);
                  console.log(data.data);
                  setExportData(result.data);
                }
                setIsLoading(false);
              };
              fetchData().catch(error => {
                console.error(error);
                setIsLoading(false);
              });


              //   "/api/v1/data/barFetch?tap=" +
              //     tap +
              //     "&year=" +
              //     props.year +
              //     "&group2=" +
              //     option2 +
              //     "&group3=" +
              //     option3 +
              //     "&group4=" +
              //     option4 +
              //     "&data=" +
              //     data +
              //     "&filter=" +
              //     props.filter +
              //     "&serviceUnit=" +
              //     props.serviceUnitFilter,
              //   {
              //     method: "GET"
              //   }
              // )
              //   .then(response => response.json())
              //   .then(
              //     result => {
              //       if (result.data.name !== null && result.data.name !== undefined && result.data.name !== "") {
              //         setName(result.data.name + " (" + props.serviceUnitName + ")");
              //       } else {
              //         setName("");
              //       }
              //       if(props.year !== ""){
              //         var mockData = '{ "datasets" : [' +
              //         '{ "label":"Peter" , "lastName":"Jones" } ]}';
              //         var obj = JSON.parse(mockData);
              //         setChart(obj)
              //       }
              //       // setIsFetch(result.data.isFetch);
              //       setChart(result.data);
              //       console.log(result.data)
              //     },
              //     error => {
              //       console.log(error);
              //     }
              //   );
            }
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [
    props.year,
    props.tap,
    props.option2,
    props.option3,
    props.option4,
    props.option5,
    props.filter,
    props.serviceUnitFilter
  ]);

  useEffect(() => {
    if (props.total) {
      axios("/api/v1/data/barTotal", {
        method: "GET"
      })
        .then(response => response.data)
        .then(
          result => {
            if (result.data.datasets !== null) {
              setName(result.data.datasets[0].label);
            } else {
              setName("");
            }
            setChart(result.data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [props.total]);

  useEffect(() => {
    // if(props.totalGender){

    //   "/api/v1/data/barTotal2",
    //   {
    //     method: "GET"
    //   }
    // )
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       if (result.data.datasets !== null && result.data.datasets.length == 1) {
    //         setName(result.data.datasets[0].label);
    //       } else if (result.data.datasets.length > 1 && props.name != ""){
    //         setName(props.name);
    //       }
    //       else {
    //         setName("");
    //       }
    //       setChart(result.data);
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );
    // }

    if (props.totalGender || props.data === 5) {
      const fetchData = async () => {
        setIsLoading(true);
        const response = await axios("/api/v1/data/barTotal2");
        if (response.status !== 200) {
          console.log("");
        } else {
          const data = response.data;

          if (data.data.datasets !== null && data.data.datasets.length === 1) {
            setName(data.data.datasets[0].label);
          } else if (data.data.datasets.length > 1 && props.name !== "") {
            setName(props.name);
          } else {
            setName("");
          }
          if (props.year !== "") {
            var mockData =
              '{ "datasets" : [' +
              '{ "label":"Peter" , "lastName":"Jones" } ]}';
            var obj = JSON.parse(mockData);
            setChart(obj);
          }
          setChart(data.data);
        }
        setIsLoading(false);
      };
      fetchData().catch(error => {
        console.error(error);
        setIsLoading(false);
      });
    }
  }, [props.totalGender]);

  useEffect(() => {
    if (props.ageRange || props.data === 8) {
      axios("/api/v1/data/ageRange", {
        method: "GET"
      })
        .then(response => response.data)
        .then(
          result => {
            if ((result.data.datasets.length = 1 && props.name !== "")) {
              setName(props.name);
            } else {
              setName("");
            }
            setChart(result.data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [props.ageRange]);

  useEffect(() => {
    if (props.serviceUnit) {
      axios("/api/v1/data/serviceUnit", {
        method: "GET"
      })
        .then(response => response.data)
        .then(
          result => {
            if ((result.data.datasets.length = 1 && props.name !== "")) {
              setName(props.name);
            } else {
              setName("");
            }
            setChart(result.data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [props.serviceUnit]);

  useEffect(() => {
    if (props.topTen) {
      const d = new Date();

      axios("/api/v1/data/topTen", {
        method: "GET"
      })
        .then(response => response.data)
        .then(
          result => {
            if (result.data.datasets.length === 1 && props.name !== "") {
              setName(props.name + monthNames[d.getMonth() + props.month]);
            } else {
              setName("");
            }
            setChart(result.data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [props.topTen]);

  useEffect(() => {
    if (props.other && props.data !== 8 && props.data !== 5) {
      axios(
        "/api/v1/data/barOther?year=" +
          props.year +
          "&data=" +
          props.data +
          "&filter=" +
          props.filter,
        {
          method: "GET"
        }
      )
        .then(response => response.data)
        .then(
          result => {
            if (props.name !== "") {
              setName(props.name);
            } else {
              setName("");
            }
            setChart(result.data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [props.other, props.year, props.filter]);

  defaults.global.defaultFontFamily = '"Sarabun", sans-serif';
  if (isLoading) {
    return (
      <div style={{ textAlign: "center" }}>
        <img style={{ width: "20%" }} src={loading} alt="..." />
      </div>
    );
  }
  // else if((props.isFetch || isFetch) && (!isLoading)){
  //   return (
  //     <div className="chart">
  //       <article className="canvas-container">
  //         <Bar
  //           data={chart}
  //           options={{
  //             title: {
  //               display: displayTitle,
  //               text: name,
  //               fontSize: 25
  //             },
  //             legend: {
  //               display: displayLegend,
  //               position: legendPosition
  //             },
  //             maintainAspectRatio: false,
  //             scales: {
  //               xAxes: [
  //                 {
  //                   stacked: true,
  //                   ticks: {
  //                     padding: 5
  //                   },
  //                   gridLines: {
  //                     display: false
  //                   }
  //                 }
  //               ],
  //               yAxes: [
  //                 {
  //                   stacked: false,
  //                   gridLines: {
  //                     drawBorder: false
  //                   },
  //                   ticks: {
  //                     beginAtZero: true,
  //                     maxTicksLimit: 6,
  //                     padding: 20,
  //                     callback(n) {
  //                       if (n < 1e3) return n;
  //                       if (n >= 1e3) return +(n / 1e3).toFixed(1) + "K";
  //                     }
  //                   }
  //                 }
  //               ]
  //             }
  //           }}
  //         />
  //       </article>
  //     </div>
  //   );
  // }
  else {
    return (
      <div className="chart">
        <article className="canvas-container">
          <Bar
            data={chart}
            options={{
              title: {
                display: displayTitle,
                text: name,
                fontSize: 25
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      userCallback: function(label, index, labels) {
                        // when the floored value is the same as the value we have a whole number
                        if (Math.floor(label) === label) {
                          return label;
                        }
                      }
                    }
                  }
                ]
              },
              legend: {
                display: displayLegend,
                position: legendPosition
                // labels: {
                //   filter: item => item.datasetIndex != 1
                // }
              },
              maintainAspectRatio: false,
              // events: true,
              // tooltips: {
              //   enabled: true
              // },
              hover: {
                animationDuration: 10
              },
              animation: {
                duration: 1,
                onComplete: function() {
                  var chartInstance = this.chart,
                    ctx = chartInstance.ctx;
                  ctx.font = Chart.helpers.fontString(
                    "10",
                    "normal",
                    '"Sarabun", sans-serif'
                  );
                  ctx.textAlign = "center";
                  ctx.textBaseline = "bottom";
                  ctx.fillStyle = "Black";

                  //ตัวเลขบน chart
                  this.data.datasets.forEach(function(dataset, i) {
                    var meta = chartInstance.controller.getDatasetMeta(i);
                    meta.data.forEach(function(bar, index) {
                      var data = dataset.data[index];
                      ctx.fillText(data, bar._model.x, bar._model.y - 5);
                    });
                  });
                }
              }
            }}
          />
        </article>
      </div>
    );
  }
};

export default ChartBar;
